import {Component, Input} from '@angular/core';
import {AcordoModel, CombustivelContrato} from '../rede-especial.interface';
import {CommonModule} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";

@Component({
  selector: 'app-acordos-existentes',
  templateUrl: './acordos-existentes.component.html',
  styleUrls: ['./acordos-existentes.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatTooltipModule,
  ]
})
export class AcordosExistentesComponent {
  @Input() combustiveis: CombustivelContrato[] = [];
  @Input() acordosExistentes: AcordoModel[] | undefined;
  @Input() msgAcordosExistentes: string | undefined;

  pegarNomeCombustivel(indCombustivel: string): string{
    const combustivel = this.combustiveis.find(x=> x.descricaoCombustivel.toUpperCase().trim() == indCombustivel.toUpperCase().trim());
    return combustivel?.combustivel || indCombustivel;
  }

}
